var searchAction = (function ($, options) {

    'use strict';

    /* Public scope and variables */
    //var allowSearch = false;
    var self = {};
    self.settings = {};

    /* add settings objects here to add additional search options. The key should be the select value. */
    self.settings.pending = {
        action: null,
        queryString: null
    };
    self.settings.site = {
        action: '/',
        queryString: 's'
    };
    self.settings.catalogue = {
        action: '//my.supplychain.nhs.uk/Catalogue/search?Query=',
        queryString: 'Query'
    };

    /* Private functions */
    function init() {
        $.extend(self.settings, options);
        bootstrap();
    }

    function bootstrap() {
        bindUI();
    }

    function bindUI() {
        $.each($('.searchform'), function () {
            var searchSelector = $(this).find('.search-select'),
                parent = $(searchSelector).parent(),
                searchField = $(parent).find('.search-field'),
                searchTrigger = $(parent).find('.search-submit');

            swapSearchStatus(searchSelector, null, parent, searchField, searchTrigger, ($(document.body).hasClass('search-results')));

            $(searchSelector).on('change', function () {
                swapSearchStatus(searchSelector, $(searchSelector).val(), parent, searchField, searchTrigger, false);
            });

            $(searchTrigger, searchField).on('click', function () {
                if ($(searchSelector).val() === 'pending') {
                    highlightRequiredAction(searchSelector);
                }
            });
        });
    }

    function swapSearchStatus(searchSelector, value, parent, searchField, searchTrigger, isSearch) {
        if (isSearch) {
            $(searchSelector).val('site').change();
            $(searchTrigger).prop("disabled", false);
            $(parent).attr('action', self.settings.site.action);
            $(searchField).attr('name', self.settings.site.queryString).prop("disabled", false);
        } else if (value === 'site' || value === 'catalogue') {
            $(searchTrigger).prop("disabled", false);
            $(parent).attr('action', self.settings[value].action);
            $(searchField).attr('name', self.settings[value].queryString).prop("disabled", false);
        } else {
            $(searchTrigger).prop('disabled', false);
            $(parent).attr('action', '/');
            $(searchField).attr('name', 's').prop('disabled', false);
        }
    }

    function highlightRequiredAction(searchSelector) {
        $(searchSelector).fadeIn(100).fadeOut(100).fadeIn(100).fadeOut(100).fadeIn(100);
    }

    init();

    return self;

}(jQuery, {}));